import type { SxProps, Theme } from '@mui/material'
import { Box } from '@mui/material'
import React from 'react'

import Title from './Title'
import Tooltip from './Tooltip'

interface LabelWithTooltipProps {
  label: string
  tooltipText: string | React.ReactNode
  sx?: SxProps<Theme>
  titleSx?: SxProps<Theme>
  tooltipSx?: object
  tooltipIconSize?: 'small' | 'medium' | 'large'
  tooltipPlacement?: 'top' | 'bottom' | 'left' | 'right'
  alignContent?: 'center' | 'start' | 'end' | 'self-start'
  fontSize?: string
  tooltipWidth?: number | string
}

const LabelWithTooltip = ({
  label,
  tooltipText,
  sx,
  titleSx,
  tooltipSx,
  tooltipIconSize = 'small',
  tooltipPlacement = 'top',
  alignContent = 'center',
  fontSize = '18px',
  tooltipWidth,
}: LabelWithTooltipProps) => {
  return (
    <Box sx={{ display: 'flex', alignItems: alignContent, ...sx }}>
      <Title sx={{ fontSize, ...titleSx }}>{label}</Title>
      <Tooltip
        text={tooltipText}
        iconSize={tooltipIconSize}
        placement={tooltipPlacement}
        sx={tooltipSx}
        tooltipWidth={tooltipWidth}
      />
    </Box>
  )
}

export default LabelWithTooltip
